/**
 * @author Code Lai（赖传峰）
 * @email codelai@staritgp.com
 * @date 2017/9/6 19:30
 * @desc 为页面添加 title 的高阶函数
 */
import { Component } from 'react'

function getDisplayName (component) {
  return component.displayName || component.name || 'Component'
}

/**
 * @operation 为 router 页面添加 title 的高阶组件
 * @param WrappedComponent {function} 被包裹的组件，最外层
 * @param title {string} 标题
 * @param action {string} 操作方式 <insert>在旧标题前插入 <replace>替换旧标题 <append>附加在旧标题后面
 * @returns {{display, new(): WithTitle, prototype: WithTitle}}
 */
export default function withTitle (WrappedComponent: any, title: string, action = 'append') {
  if (!title) {
    throw new RangeError('2nd param is required')
  }
  if (!['insert', 'replace', 'append'].includes(action)) {
    throw new RangeError('The value of 3rd param should be "insert", "replace" or "append"')
  }

  return class WithTitle extends Component {
    static display = `WithTitle(${getDisplayName(WrappedComponent)})`
    title: string = ''

    componentDidMount () {
      const titleElements = document.getElementsByTagName('title')
      if (titleElements.length && title) {
        this.title = titleElements[0].text
        titleElements[0].text = (() => {
          let _title = ''
          switch (action) {
          case 'insert':
            _title = `${title} - ${this.title}`
            break
          case 'replace':
            _title = title
            break
          case 'append':
            _title = `${this.title} - ${title}`
            break
          }
          return _title
        })()
      }
    }

    componentWillUnmount () {
      const titleElements = document.getElementsByTagName('title')
      if (titleElements.length && title) {
        titleElements[0].text = this.title
      }
    }

    render () {
      // @ts-ignore
      return <WrappedComponent {...this.props} title={title} />
    }
  }
}
